import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AmazonRegisterFormBaseComponent } from '../../common/amazon-register-form-base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-amazon-register-form-ce-qa',
  templateUrl: '../../common/amazon-register-form.component.html',
  styleUrls: ['../../common/amazon-register-form.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AmazonRegisterFormMxQaComponent extends AmazonRegisterFormBaseComponent implements OnInit {

  endpoint = 'https://stg-rg2.samsungcareplus.com/us';
  redirectUrl;

  constructor(protected fb: FormBuilder,
              private route: ActivatedRoute,
              private router: Router) {
    super(fb);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.redirectUrl = params.redirectUrl;
      console.log(`redirectUrl = ${ this.redirectUrl }`);
    });
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isSubmitting || this.isSubmitted) {
      console.warn('Submission blocked: already submitting or submitted.');
      return;
    }

    this.isSubmitting = true;

    if (!this.activationForm.valid) {
      console.warn('Form is invalid. Please correct the errors.');
      this.isSubmitting = false;
      return;
    }

    const formData = this.activationForm.value;

    const urlEncodedData = new URLSearchParams();
    urlEncodedData.append('firstName', formData.firstName);
    urlEncodedData.append('lastName', formData.lastName);
    urlEncodedData.append('email', formData.email);

    fetch(`${this.endpoint}/amazon/accountRegistration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: urlEncodedData.toString()
    })
    .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          this.isSubmitted = true;
          const redirect = `${this.redirectUrl}&infoField1=${encodeURIComponent(formData.email)}&infoField2=${encodeURIComponent(formData.firstName)}&infoField3=${encodeURIComponent(formData.lastName)}&userId=${encodeURIComponent(response.userId)}`;
          console.log('Redirecting to:', redirect);
          window.location.replace(redirect);
        } else {
          this.isSubmitted = false;
          this.isSubmitting = false;
          alert('Form submission failed.');
          console.error('Submission error:', response);
        }
      })
      .catch(error => {
        this.isSubmitted = false;
        this.isSubmitting = false;
        alert('Network Error Occurred.');
        console.error('Network error:', error);
      });
  }

  onDblClick($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    console.log('dblclick');
    return;
  }
}
